/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ClientRequestProtocolAddNewRequestRequest,
  ClientRequestProtocolGetCrDetailsRequest,
  ClientRequestProtocolGetCrDetailsResponse,
  ClientRequestProtocolGetCrHasNewBadgeResponse,
  ClientRequestProtocolGetCrListCountRequest,
  ClientRequestProtocolGetCrListCountResponse,
  ClientRequestProtocolGetCrListRequest,
  ClientRequestProtocolGetCrListResponse,
  ClientRequestProtocolGetUploadUrlRequest,
  ClientRequestProtocolGetUploadUrlResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Cr<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ClientRequest
   * @name ListCreate
   * @request POST:/cr/list
   */
  listCreate = (data: ClientRequestProtocolGetCrListRequest, params: RequestParams = {}) =>
    this.http.request<ClientRequestProtocolGetCrListResponse, any>({
      path: `/cr/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientRequest
   * @name ListCountCreate
   * @request POST:/cr/list/count
   */
  listCountCreate = (data: ClientRequestProtocolGetCrListCountRequest, params: RequestParams = {}) =>
    this.http.request<ClientRequestProtocolGetCrListCountResponse, any>({
      path: `/cr/list/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientRequest
   * @name DetailsCreate
   * @request POST:/cr/details
   */
  detailsCreate = (data: ClientRequestProtocolGetCrDetailsRequest, params: RequestParams = {}) =>
    this.http.request<ClientRequestProtocolGetCrDetailsResponse, any>({
      path: `/cr/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientRequest
   * @name PostCr
   * @request POST:/cr/add
   */
  postCr = (data: ClientRequestProtocolAddNewRequestRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/cr/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientRequest
   * @name UploadUrlCreate
   * @request POST:/cr/upload-url
   */
  uploadUrlCreate = (data: ClientRequestProtocolGetUploadUrlRequest, params: RequestParams = {}) =>
    this.http.request<ClientRequestProtocolGetUploadUrlResponse, any>({
      path: `/cr/upload-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientRequest
   * @name GetCr
   * @request GET:/cr/new
   */
  getCr = (params: RequestParams = {}) =>
    this.http.request<ClientRequestProtocolGetCrHasNewBadgeResponse, any>({
      path: `/cr/new`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
